module.exports = __webpack_public_path__ + "img/sld_dcdb_t1_b1.e7f4c988.svg";